import { render, staticRenderFns } from "./ThematicCases.vue?vue&type=template&id=31aae512&scoped=true&"
import script from "./ThematicCases.vue?vue&type=script&lang=js&"
export * from "./ThematicCases.vue?vue&type=script&lang=js&"
import style0 from "./ThematicCases.vue?vue&type=style&index=0&id=31aae512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aae512",
  null
  
)

export default component.exports